<template>
  <div class='home'>
    <div v-if='!showNotice' class='wrapper'>
      <img src='../assets/imgs/home_bg.png' alt='' class='home_bg'>
      <p class='text-book' @click='goRouter("/ordersearch")'>教材征订</p>
      <p class='press' @click='goRouter("/press")'>出版社数据</p>
      <p class='library' @click='goRouter("/library")'>图书馆</p>
      <p class='user' @click='goRouter("/my")'>个人中心</p>
    </div>

    <div v-if='showNotice' class='notice-wrapper'>
      <div class='carousel'>
        <carousel :per-page='1' pagination-color='#cccccc' pagination-active-color='#3383b5' @pageChange='onPageChange' >
          <slide v-for='(item,index) in list' :key='index' class='slider'>
            <p class='title'>{{ item.title }}</p>
            <div class='content' v-html='item.content'/>
            <img v-if='showClose' src='../assets/imgs/notice_close.png' class='icon-close' @click='closeNotice'>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { NOTICE_LIST } from '@/api'
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      list: [],
      showClose: false,
      showNotice: false,
    }
  },

  created() {
    this.checkShowNotice()
  },

  methods: {
    // 检测是否显示notice
    checkShowNotice() {
      let hasShowNotice = localStorage.getItem('HAS_SHOW_NOTICE')
      if (!hasShowNotice) {
        this.getNotice()
      }
    },

    // slide
    onPageChange(page) {
      if (this.list.length > 0 && page == this.list.length - 1) {
        setTimeout(() => {
          this.showClose = true
        }, 200)
      } else {
        this.showClose = false
      }
    },

    // 关闭
    closeNotice() {
      this.showNotice = false
      localStorage.setItem('HAS_SHOW_NOTICE',true)
    },

    // 获取公告
    getNotice() {
      NOTICE_LIST().then(res=>{
        if (res.data.code === 0) {
          let list = res.data.data
          let len = list.length
          list.forEach(e=>{
            e.content = this._addIndent(e.content)
          })
          this.list = list
          this.showNotice = len > 0 ? true : false
          this.showClose = len === 1 ? true : false
        }
      })
    },

    // 添加缩进
    _addIndent(val) {
      let br = '<br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
      let content = val.replace(/[\r\n]/g,br)
      return '<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + content + '</p>'
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.home {
  width: 100%;
  height: 100vh;
  min-width: 1920px * @scale;
  min-height: 1080px * @scale;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .wrapper {
    width: 1920px * @scale;
    height: 1080px * @scale;
    position: relative;
    .home_bg {
      display: block;
      width: 1920px * @scale;
      height: 1080px * @scale;
    }
    p {
      height: 68px * @scale;
      line-height: 68px * @scale;
      font-size: 40px * @scale;
      position: absolute;
      right: 0;
      text-indent: 50px * @scale;
      font-weight: 500;
      cursor: pointer;

      &.text-book {
        width: 630px * @scale;
        bottom: 493px * @scale;
        letter-spacing: 30px * @scale;
      }

      &.press {
        width: 725px * @scale;
        letter-spacing: 10px * @scale;
        bottom: 368px * @scale;
      }

      &.library {
        width: 819px * @scale;
        letter-spacing: 61px * @scale;
        bottom: 236px * @scale;
      }

      &.user {
        width: 913px * @scale;
        letter-spacing: 24px * @scale;
        bottom: 110px * @scale;
      }
    }
  }

  .notice-wrapper {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);

    .carousel {
      width: 1000px;
      height: 800px;
      position: absolute;
      top: 10%;
      left: 50%;
      margin-left: -500px;
      background: #ffffff;
      border-radius: 5px;
      box-sizing: border-box;
      .slider {
        width: 1000px;
        height: 730px;
        position: relative;

        .title {
          height: 64px;
          line-height: 64px;
          text-align: center;
          background: @blue-d;
          color: #ffffff;
          font-size: 32px;
          font-weight: 500;
        }
        .content {
          font-size: 22px;
          color: #666666;
          line-height: 1.5;
          box-sizing: border-box;
          padding: 10px 20px;
        }
        .icon-close {
          width: 24px;
          height: 24px;
          position: absolute;
          right: 28px;
          top: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Home.vue